/**
 * Shim for @vertex-protocol/client
 *
 * Re-exports the real @vertex-protocol/client package (which is @nadohq/client
 * via the package.json npm alias) and adds Vertex-SDK compatibility aliases
 * for symbols that were renamed or removed in the Nado fork.
 *
 * The local node_modules symlink provides a stable relative path:
 *   shims/ → ../node_modules/@vertex-protocol/client → @nadohq/client (pnpm)
 */
/* eslint-disable @typescript-eslint/no-require-imports */
const BigNumber = require('bignumber.js').default || require('bignumber.js');
// Load the real @nadohq/client package directly (not through the
// @vertex-protocol/client alias, which webpack maps to this shim).
const clientPkg = require('@nadohq/client');

// Re-export everything from the real client
module.exports = {
  ...clientPkg,

  // ---- Backward-compat aliases ----

  // BigDecimal (original Vertex SDK) → BigNumber (bignumber.js)
  toBigDecimal: (val) => new BigNumber(val),
  toFixed: (val, decimals) => new BigNumber(val).toFixed(decimals),
  BigDecimal: BigNumber,
  BigDecimals: {
    ZERO: new BigNumber(0),
    ONE: new BigNumber(1),
    TWO: new BigNumber(2),
    NEGATIVE_ONE: new BigNumber(-1),
    fromPercent: (pct) => new BigNumber(pct).dividedBy(100),
    toPercent: (val) => new BigNumber(val).multipliedBy(100),
    abs: (val) => new BigNumber(val).abs(),
    isMathematicalInteger: (val) => new BigNumber(val).isInteger(),
  },
  sumBigDecimalBy: (arr, fn) =>
    arr.reduce(
      (acc, item) => acc.plus(new BigNumber(fn(item))),
      new BigNumber(0),
    ),

  // EIP-712 aliases (Nado renamed getVertex* → getNado*)
  getVertexEIP712Values: clientPkg.getNadoEIP712Values,
  getVertexEIP712Domain: clientPkg.getNadoEIP712Domain,
  getVertexEIP712PrimaryType: clientPkg.getNadoEIP712PrimaryType,
  getVertexEIP712Types: clientPkg.getNadoEIP712Types,

  // ABI name alias
  VERTEX_ABIS: clientPkg.NADO_ABIS || {},

  // VLP is a Vertex-only product not present in Stackd Perps.
  // Use a sentinel value that won't match any real product ID.
  VLP_PRODUCT_ID: -1,

  // LP balance calculation stubs (no LP pools in Stackd Perps)
  calcIndexerLpBalanceValue: (_balance, _market) => new BigNumber(0),
  calcIndexerLpTokenValue: (_balance, _market) => new BigNumber(0),
  calcLpBalanceValue: (_balance, _market) => new BigNumber(0),
  calcLpTokenValue: (_market, _oraclePrice) => new BigNumber(0),

  // Trigger order detection — not present in Nado SDK
  isTriggerOrderNonce: (_nonce) => false,
  getTriggerOrderNonce: () => (BigInt(Date.now()) * 1000n).toString(),

  // Legacy rewards epoch constant, unused by Stackd Perps runtime surfaces.
  LBA_AIRDROP_EPOCH: 0,

  // Client factory alias
  VertexClient: clientPkg.NadoClient,
  createVertexClient: clientPkg.createNadoClient,
};
